"use client";

import type { PropsWithChildren } from "react";
import { SoundEngineProvider, SoundtrackDirectorProvider } from "@thehoneyjar/sound-engine";
import { INTERFACE_SOUNDTRACK_SCENES } from "@/constants/soundtrack";

export const InterfaceSoundProvider = ({ children }: PropsWithChildren<{}>) => {
  return (
    <SoundEngineProvider
      config={{
        basePath: "",
        defaultVolume: 1.0,
        enableLocalStorage: true,
      }}
    >
      <SoundtrackDirectorProvider scenes={INTERFACE_SOUNDTRACK_SCENES}>
        {children}
      </SoundtrackDirectorProvider>
    </SoundEngineProvider>
  );
};
